module.exports = __webpack_public_path__ + "static/media/home2.bee36bb7.jpg";